<template>
  <div class="wrapper">
    <div class="title">YYTools 生成管理短网址、二维码</div>
    <div class="service">App推广，产品推广，短信营销 </div>
    <div class="view-list"><a href="/short-url-list">查看我的短网址列表>></a></div>
    <div class="input-box">
      <input v-model="LinkForm.link" placeholder="请填写需要转换的链接" type="text" clearable><el-button type="primary" @click="onChange">转换</el-button>
    </div>
    <div class="short-link" v-if="LinkForm.short_url">短链接: <a :href="LinkForm.short_url" target="_blank">{{LinkForm.short_url}}</a> <el-button @click="handleCopy" type="primary" class="copy-text" :data-clipboard-text="LinkForm.short_url" size="mini">复制</el-button></div>
    <div class="qrcode">
      <img v-if="LinkForm.short_url" width="280px" height="280px" :src="'https://yytools-api.mockuai.com/api/test/page/qrcode?text='+LinkForm.short_url" alt="">
    </div>
    <div class="tips">专业 · 简单 · 易用   复制黏贴，一键生成，更便捷的操作流程，提高您的转换效率</div>
  </div>
</template>
<script>
import {Message} from 'element-ui';
import Clipboard from 'clipboard';
export default {
  name: 'ShortUrl',
  data() {
    return {
      LinkForm: {
        link: null,
        short_url: null,
        title: null,
      },
    }
  },
  mounted() {
  },
  methods: {
    handleCopy() {
      const clipboard = new Clipboard('.copy-text');
      clipboard.on('success', (e) => {
        Message.success({
          message: '复制成功！',
          type: 'info',
          center: true
        });
        clipboard.destroy();
      });
      clipboard.on('error', (e) => {
        Message.error({
          message: '复制失败！',
          type: 'info',
          center: true
        });
        clipboard.destroy();
      });
    },
    onChange: function (val) {
      const reg = new RegExp(/^http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?/)
      if(!reg.test(this.LinkForm.link)){
        Message.error({
          message: '网址格式不正确，需要以http://或https://开头！',
          type: 'info',
          center: true
        });
      }else{
        this.handleLink()
      }
    },
    //新增/编辑 页面配置
    handleLink() {
      lib.tmsapi.post({
        api: 'api/test/short/add',
        data: this.LinkForm,
        success: (res) => {
          // 提示成功
          Message.success({
            message: '转换链接成功',
            type: 'info',
            center: true
          });
          if(res.data){
            this.LinkForm.short_url = res.data;
          }
        },
      })
    },

  },
}
</script>
<style lang="scss" scoped>
.wrapper{
  padding-top: 100px;
  .title{
    width: 100%;
    height: 40px;
    font-size: 40px;
    color: #505050;
    margin-bottom: 30px;
    text-align: center;
  }
  .service{
    width: 100%;
    height: 22px;
    font-size: 22px;
    color: #999;
    text-align: center;
    margin-bottom: 50px;
  }
  .view-list{
    width: 100%;
    height: 22px;
    font-size: 18px;
    text-align: center;
    margin-bottom: 30px;
  }
  .input-box{
    width: 100%;
    height: 45px;
    text-align: center;
    input{
      width: 570px;
      height: 23px;
      font-size: 18px;
      font-weight: bold;
      border: 1px solid #bfbfbf;
      border-right: 0;
      vertical-align: bottom;
      padding: 10px;
      box-sizing: content-box;
      border-radius-top-left:4px;
      border-radius-bottom-left:4px;
      &::placeholder{
        font-weight: normal;
        font-size: 16px;
      }
    }
    button{
      width: 120px;
      height: 45px;
      outline: none;
      margin: 0;
      padding: 0;
      border: 1px solid transparent;
      vertical-align: bottom;
      color: #fff;
      font-size: 16px;
    }
  }
  .tips{
    width: 100%;
    height: 22px;
    font-size: 16px;
    color: #999;
    text-align: center;
    position: absolute;
    bottom: 50px;
  }
  .short-link{
    padding-top: 35px;
    text-align: center;
  }
  .qrcode{
    text-align: center;
    padding-top: 14px;
  }
}
</style>

